var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('v-expand-transition',[(_vm.showLoading)?_c('v-overlay',{attrs:{"z-index":"999","opacity":"1"}},[_c('div',{attrs:{"id":"dots5"}},_vm._l((new Array(5)),function(i){return _c('span')}),0),_c('div',{staticClass:"text-center text-h5 mt-8"},[_vm._v("Loading")])]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }